/**
 * group (그룹) orval 래퍼
 */
import { customInstance } from "../custom-instance";
// ── API 함수 ──
export async function getGroupList() {
    return customInstance({
        url: "/group",
        method: "GET",
    });
}
export async function getGroupListWithPermission() {
    return customInstance({
        url: "/group/with-permissions",
        method: "GET",
    });
}
export async function createGroupPermission(data) {
    return customInstance({
        url: "/group-page-permission",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data,
    });
}
export async function deleteGroupPermission(data) {
    return customInstance({
        url: `/group-page-permission/${data.groupId}/${data.pageId}`,
        method: "DELETE",
    });
}
// ── SDK 객체 ──
export const groupApi = {
    getGroupList,
    getGroupListWithPermission,
    createGroupPermission,
    deleteGroupPermission,
};
